import { db } from './db.js';

/* Subtítulos externos (OpenSubtitles, a través del servidor). El reproductor los pinta él mismo
   sobre el vídeo en lugar de usar <track>: así valen igual con el vídeo convertido (cuya línea de
   tiempo no empieza en cero), en HLS y en los WebView antiguos de las TV, y se pueden adelantar o
   retrasar. El subtítulo elegido para cada título se guarda en el dispositivo con su texto: la
   próxima vez se carga solo, sin red y sin gastar cupo. */

const STORE_PREFIX = 'subs:';

function toSeconds(stamp) {
    const m = /^(?:(\d+):)?(\d{1,2}):(\d{2})[.,](\d{1,3})$/.exec(stamp.trim());
    if (!m) return NaN;
    return (Number(m[1]) || 0) * 3600 + Number(m[2]) * 60 + Number(m[3]) + Number((m[4] + '00').slice(0, 3)) / 1000;
}

/** Texto de una entrada: sin etiquetas de estilo ni de posición, con los saltos de línea. */
function cleanText(lines) {
    return lines.join('\n')
        .replace(/\{\\[^}]*\}/g, '')
        .replace(/<(?!\/?[ib]>)[^>]*>/gi, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .trim();
}

/** WebVTT o SRT → [{ start, end, text }] ordenado por inicio. `text` conserva solo <i> y <b>. */
export function parseSubtitles(source) {
    const cues = [];
    const blocks = String(source || '').replace(/^﻿/, '').replace(/\r\n?/g, '\n').split(/\n{2,}/);
    blocks.forEach((block) => {
        const lines = block.split('\n');
        const at = lines.findIndex((l) => l.indexOf('-->') !== -1);
        if (at === -1) return;
        const parts = lines[at].split('-->');
        const start = toSeconds(parts[0]);
        const end = toSeconds(String(parts[1]).trim().split(/\s+/)[0]);
        if (!isFinite(start) || !isFinite(end) || end <= start) return;
        const text = cleanText(lines.slice(at + 1));
        if (text) cues.push({ start, end, text });
    });
    return cues.sort((a, b) => a.start - b.start);
}

/** Entradas visibles en el instante `time` (normalmente una; dos si se solapan). */
export function cuesAt(cues, time) {
    if (!cues || !cues.length) return [];
    let lo = 0;
    let hi = cues.length - 1;
    // Última entrada que empieza en `time` o antes.
    while (lo < hi) {
        const mid = (lo + hi + 1) >> 1;
        if (cues[mid].start <= time) lo = mid; else hi = mid - 1;
    }
    const out = [];
    for (let i = Math.max(0, lo - 2); i <= lo; i++) {
        if (cues[i].start <= time && time < cues[i].end) out.push(cues[i]);
    }
    return out;
}

/** HTML seguro de una entrada: se escapa todo y solo se devuelven cursiva y negrita. */
export function cueHtml(text) {
    return String(text)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/&lt;(\/?)([ib])&gt;/gi, '<$1$2>')
        .replace(/\n/g, '<br>');
}

export const subtitleStore = {
    key(profileId, kind, id) {
        return STORE_PREFIX + (profileId || 'local') + ':' + kind + ':' + id;
    },
    get(key) {
        return db.get('meta', key).catch(() => null);
    },
    set(key, value) {
        return db.put('meta', key, value).catch(() => {});
    },
    remove(key) {
        return db.delete('meta', key).catch(() => {});
    }
};
